// extracted by mini-css-extract-plugin
export default {"news_container":"News_news_container__rGOP+","container":"News_container__PmJ-I"};